import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { CommonPropertyDetailMenuEnum } from './common-property-detail-page.enum';
import { Subscription } from 'rxjs';
import { CommonPropertyDetailConstant } from './common-property-detail-page.constant';
import { ReportsViewEnum } from 'src/app/reports/models/enums/reports.enum';

import { CommonPropertyDetailPageService } from './common-property-detail-page.service';
import { ActivatedRoute } from '@angular/router';
import { apiEndPoints } from 'src/app/common/constants/api-endpointsconstant';
import { PropertyCategoryEnum } from '../common/propertyCategory.enum';

@Component({
  selector: 'app-common-property-detail-page',
  templateUrl: './common-property-detail-page.component.html',
  styleUrls: ['./common-property-detail-page.component.scss']
})
export class CommonPropertyDetailPageComponent {
  @Input() property:any;
  isMultiPropInProject = false;
  chartsection={
    chart1: true,
    chart2: true,
    chart3: true,
    chart4: true,
    chart5: true,
    chart6: true,
    chart7: true
  }

  tableSection = {
    table0 :false,
    table1 :true,
    table2 :true,
    table3 :true,
    table4 :true,
    table5 :true,
    table6 :true,
    table7 :true,
    table8 :true,
    table9 :true,
  }
   isCategoryMatch: boolean = false;
  //  isAllTransactions: boolean = false;
   propertyLandParcelData: any[] = [];
  // overViewMenu = CommonPropertyDetailConstant.overViewMenu;
  currentReportView: number = ReportsViewEnum.mapView;
  currentScroll: any = CommonPropertyDetailMenuEnum.overview;
  commonPropertyDetailMenuEnum = CommonPropertyDetailMenuEnum
  apiEndPoints= apiEndPoints;
  propertyCategoryEnum=  PropertyCategoryEnum;
 fullMenuList = [...CommonPropertyDetailConstant.overViewMenu];
   // dynamic list to show on UI (filtered)
 dataState: Record<string, boolean> = {};
 visibleMenuList: any[] = [];
  currentLang: string = '';
  languageSub$: Subscription = new Subscription();
  currentReportView$: Subscription = new Subscription();
  items:any = [];
  count:any=null;
  params:any;
  property_category='';
  landParceldata: any;
    constructor(
      private sharedService: SharedService,
      public reportService: ReportService,
      private commonPropertyDetailPageService: CommonPropertyDetailPageService,
      private route:ActivatedRoute

    ) {


     }
  ngOnInit(){

  }
  ngOnChanges(): void {
     this.fullMenuList.forEach(menu => {
      this.dataState[String(menu.name)] = false;
    });

    this.scrollPoint(String(this.commonPropertyDetailMenuEnum.overview));

    // show overview first
    this.dataState[String(CommonPropertyDetailMenuEnum.overview)] = true;

    this.chartsection={
      chart1: true,
      chart2: true,
      chart3: true,
      chart4: true,
      chart5: true,
      chart6: true,
      chart7: true
    }

    this.tableSection = {
      table0 :false,
      table1 :true,
      table2 :true,
      table3 :true,
      table4 :true,
      table5 :true,
      table6 :true,
      table7 :true,
      table8 :true,
      table9 :true,
    }

    if (this.property?.parent_property_uid) {
      this.property['property_uid'] = this.property?.parent_property_uid;
    }

    if (this.property?.is_multi_parcel) {
      this.tableSection.table0 = true;
    } else {
      this.tableSection.table0 = false;
      this.dataState[String(CommonPropertyDetailMenuEnum.propertyLandParcel)] = false;
    }

    if (this.property) {
      this.reportService.detailPageState$.next(true);
      this.landparceldata();
    }
    this.route.queryParams.subscribe(param => {
      this.params = param;
      // console.log('TEST: URL Params loaded:', param);
    })
    this.isMultiPropInProject = (this.property?.project_property_count > 1) ? true : false;
    let paramcat: string[] = [];
    const categoryParam = this.params['property_category'] || this.params['property_cat_subcat'];
    if (categoryParam) {
      paramcat = categoryParam.toLowerCase().split(',');
    }
    let propcat = this.property?.property_category?.toLowerCase() || null;
    if (paramcat.length > 0) {
      // this.isAllTransactions = false;
      // Set flag: true if any param category matches in property's categories
      this.isCategoryMatch = !!paramcat?.find((item: string) => propcat?.includes(item));
      // this.isCategoryMatch = !paramcat?.length || paramcat.some(item => propcat?.includes(item) ?? false);
    }
    //  {
    //     this.isAllTransactions = true;
    // }
    let categ = paramcat?.find((item: string) => propcat?.includes(item)) || propcat?.split(',')[0]
    if (categ) {
      this.property_category = categ;
    }
    // if (this.property_category == PropertyCategoryEnum.MultiStoryOffice) {
    //   // Find the two objects
    //   const index3: any = this.fullMenuList.findIndex(item => item.name === CommonPropertyDetailMenuEnum.PropertyRetailRental);
    //   const index4: any = this.fullMenuList.findIndex(item => item.name === CommonPropertyDetailMenuEnum.PropertyOfficeRental);

    //   // Swap their names
    //   [this.fullMenuList[index3], this.fullMenuList[index4]] = [this.fullMenuList[index4], this.fullMenuList[index3]];
    // }

    //  if(this.isCategoryMatch && this.property_category == PropertyCategoryEnum.VillaHouse){
    //   this.dataState[String(CommonPropertyDetailMenuEnum.PropertyunitPrices)] = false;
    //  }
    //  if(this.isCategoryMatch && this.property_category == PropertyCategoryEnum.MultiStoryResidential){
    //   this.dataState[String(CommonPropertyDetailMenuEnum.ResidentialUnits)] = true;
    //  }

    // build visible menus initially
    this.updateVisibleMenus();
    this.setLang();
    this.getReportView();
  }

updateSectionFromChild(isEmpty: boolean, menuEnum: number) {
  const key = String(menuEnum);
  const hasData = !isEmpty;


  const prev = this.dataState[key];

  // ✅ Update menu visibility if data presence changed
  if (prev !== hasData) {
    this.dataState[key] = hasData;
    this.updateVisibleMenus();
  }
  if (menuEnum === this.commonPropertyDetailMenuEnum.propertyLandParcel) {
    this.tableSection.table0 = hasData;
  }
  if (menuEnum === this.commonPropertyDetailMenuEnum.PropertylandPriceTable) {
    this.tableSection.table1 = hasData;
  }
  else if (menuEnum === this.commonPropertyDetailMenuEnum.PropertyPrices) {
    this.tableSection.table2 = hasData;
  }
  else if (menuEnum === this.commonPropertyDetailMenuEnum.PropertyunitPrices) {
    this.tableSection.table3 = hasData;
  }
  else if (menuEnum === this.commonPropertyDetailMenuEnum.PropertyResidentialRental) {
    this.tableSection.table4 = hasData;
  }
  else if (menuEnum === this.commonPropertyDetailMenuEnum.PropertyRetailRental) {
    this.tableSection.table5 = hasData;
  }
  else if (menuEnum === this.commonPropertyDetailMenuEnum.PropertyOfficeRental) {
    this.tableSection.table6 = hasData;
  }
  else if (menuEnum === this.commonPropertyDetailMenuEnum.PropertyWarehouseRental) {
    this.tableSection.table7 = hasData;

  }  else if (menuEnum === this.commonPropertyDetailMenuEnum.municipalRegulations) {
    this.tableSection.table8 = hasData;
  }  else if (menuEnum === this.commonPropertyDetailMenuEnum.ResidentialUnits) {
    this.tableSection.table9 = hasData;
  }

}


  //   updateVisibleMenus() {
  //   this.visibleMenuList = this.fullMenuList.filter(
  //     menu =>
  //       this.dataState[String(menu.name)] === true ||
  //       String(menu.name) === String(CommonPropertyDetailMenuEnum.overview)
  //   );
  // }
  updateVisibleMenus() {
    // Free menu enums (only confirmed from constant: overview, land parcel, amenities)
    const freeMenuEnums = [
      CommonPropertyDetailMenuEnum.overview,
      CommonPropertyDetailMenuEnum.propertyLandParcel,
      CommonPropertyDetailMenuEnum.PropertylandPriceTable,
      CommonPropertyDetailMenuEnum.amenities,
      CommonPropertyDetailMenuEnum.PropertyPrices,
      CommonPropertyDetailMenuEnum.PropertyunitPrices,
      CommonPropertyDetailMenuEnum.ResidentialUnits,
      CommonPropertyDetailMenuEnum.PropertyResidentialRental,
      CommonPropertyDetailMenuEnum.PropertyRetailRental,
      CommonPropertyDetailMenuEnum.PropertyOfficeRental,
      CommonPropertyDetailMenuEnum.PropertyWarehouseRental,
      CommonPropertyDetailMenuEnum.apartmentPriceAnalysis,
      CommonPropertyDetailMenuEnum.residentialAnalysis,
      CommonPropertyDetailMenuEnum.retailAnalysis,
      CommonPropertyDetailMenuEnum.officeAnalysis,
      CommonPropertyDetailMenuEnum.warehouseAnalysis,
      CommonPropertyDetailMenuEnum.landPricesProject,
      CommonPropertyDetailMenuEnum.VillaPriceAnalysis,
      CommonPropertyDetailMenuEnum.municipalRegulations,

    ];

    this.visibleMenuList = this.fullMenuList.filter(menu => {
      const key = String(menu.name);
      const hasData = this.dataState[key] === true;

      // Always show overview
      if (key === String(CommonPropertyDetailMenuEnum.overview)) return true;

      // No data? Hide
      if (!hasData) return false;

      // If category matches, show everything
      // if (this.isCategoryMatch)
      //   return true;

      // Else, show only free menus
      // Optional: If subscription needed, add && this.isSubscribed for paid
      return freeMenuEnums.some(freeEnum => String(freeEnum) === key);
    });
    // console.log('TEST: Visible Menus Updated - Length:', this.visibleMenuList.length, 'Items:', this.visibleMenuList.map(m => ({ name: m.name, label: m.label })), 'Flag:', this.isCategoryMatch);
  }


  ngAfterViewInit(): void {
    setTimeout(() => {
      this.scrollPoint(String(this.commonPropertyDetailMenuEnum.overview));
    }, 0);
  }

  setLang(): void {
    this.languageSub$ = this.sharedService.language$.subscribe(lang => {
      this.currentLang = lang;
      this.getAmenities();

    })
  }

  getReportView() {
    this.currentReportView$ = this.reportService.reportView$.subscribe((view: number) => {
      this.currentReportView = view;
    });
  }


  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }

  scrollPoint(menu: string) {
    this.sharedService.scrollMenu(menu);
  }

  backToTransaction() {
    if(!this.reportService.projectReportView){
       this.reportService.isDetailPageOpen = false;
    }
    // this.reportService.isDetailPageOpen = false;
    this.reportService.transactionPropertyDetails.next(false);

  }

 getAmenities(){
    this.commonPropertyDetailPageService.getPropertyAmneities(this.property?.property_uid).subscribe({
      next:(res:any)=>{
        if(res.status == 200 && res.data?.amenities){
          this.items = res.data?.amenities ? res.data?.amenities.split(','): [];
          this.count = this.items.length > 0 ? this.items.length : null;
        }else{
          this.items= [];
          this.count=null;
          this.fullMenuList = this.fullMenuList.filter(
            m => m.name !== CommonPropertyDetailMenuEnum.amenities
          );
        }

      },error:(err)=>{
        this.items= [];
        this.count=null;
        this.fullMenuList = this.fullMenuList.filter(
          m => m.name !== CommonPropertyDetailMenuEnum.amenities
        );
      }
    })
  }

  // removeTopMenu(type:number){
  //   this.overViewMenu = this.overViewMenu.filter((m: any) => m.name !== type);
  // }

  updateSection(event:boolean, type:number){
    if(type == CommonPropertyDetailMenuEnum.landPricesProject){
        this.chartsection.chart1 = !event;
    }if(type == CommonPropertyDetailMenuEnum.VillaPriceAnalysis){
        this.chartsection.chart2 = !event;
    }if(type == CommonPropertyDetailMenuEnum.apartmentPriceAnalysis){
        this.chartsection.chart3 = !event;
    }if(type == CommonPropertyDetailMenuEnum.residentialAnalysis){
        this.chartsection.chart4 = !event;
    }if(type == CommonPropertyDetailMenuEnum.retailAnalysis){
        this.chartsection.chart5 = !event;
    }if(type == CommonPropertyDetailMenuEnum.officeAnalysis){
        this.chartsection.chart6 = !event;
    }if(type == CommonPropertyDetailMenuEnum.warehouseAnalysis){
        this.chartsection.chart7 = !event;
    }
  }

  landparceldata(){
    this.commonPropertyDetailPageService
      .getPropertyLandParcel(this.property?.property_uid, null, 1000, 0, this.property?.parcel_uid).subscribe({
        next: (res: any) => {
          if (res?.data && res?.data.length > 0) {
           this.landParceldata = res.data;
          } else {
            this.landParceldata = [];
          }
        }, error: (err) => {
          this.landParceldata = [];
        }
      })
  }
}
